import { Container } from 'components/gruenland/atoms/container/Container';
import { FooterCard, FooterCardProps } from './FooterCard';

export type FooterCardsProps = {
  cards: Array<FooterCardProps>;
};

export const FooterCards: React.FC<FooterCardsProps> = ({ cards }) => {
  return (
    <div className="bg-neutrals-gray-light">
      <Container className="py-[30px]">
        <div className="grid gap-[30px] md:grid-cols-4 lg:gap-[160px]">
          {cards.map((x, i) => (
            <FooterCard key={i} icon={x.icon} title={x.title} text={x.text} />
          ))}
        </div>
      </Container>
    </div>
  );
};
